import React, { useState } from 'react'

import ContentfulLongText from '../../ContentfulLongText'
import { Ratings } from '../Ratings'

import googleIcon from '../../../images/icons/google-icon.svg'

import './blog-testimonial.css'

const getFirstLetter = (name) => {
    return name.charAt(0);
};

export const BlogTestimonial = ({ postData }) => {
    const [ readMore, setReadMore ] = useState(false)
    let actionClass = readMore ? ' show':' hidden'
    return postData.googleReviews !== null && (
        <div className={`blog-testimonial${actionClass}`}>
            <div className={`grid col-1-md lists`}>
                {postData.googleReviews.map((item, index) => {
                    const commentLength = item.comment !== null ? item.comment.comment.length:0
                    return (
                        <div key={index} className='item'>
                            <div className='flex head'>
                                {item.image !== null 
                                ? <img className='mb-0' src={item.image.gatsbyImageData.images.fallback.src} alt={item.name || `Testimonial Item ${index}`} /> 
                                : <div className='flex align-center justify-center' style={{ 
                                    width: '40px', 
                                    height: '40px', 
                                    fontSize: '18px',
                                    fontWeight: 700,
                                    color: 'var(--primary-white-star)', 
                                    backgroundColor: 'red', 
                                    borderRadius: '50px' 
                                    }}>{getFirstLetter(item.name)}</div>}
                                
                                <div className='name'>
                                    <p className='mb-0 text--dark'>{item.name}</p>
                                    <div className='flex wrap align-center'><Ratings percentage={item.ratings} /> <span>{item.postedDate}</span></div>
                                </div>
                            </div>
                            {item.comment !== null && <div className='comment'>
                                <ContentfulLongText longTextContent={item.comment.comment}/>
                                {(commentLength >= '100') && (
                                    <>{readMore ? <button type='button' className='btn--plain' onClick={() => setReadMore(false)}>Read Less</button>:<button type='button' className='btn--plain' onClick={() => setReadMore(true)}>Read More</button>}</>
                                )}
                            </div>}
                            <div className='flex align-center foot'>
                                <img className='mb-0' src={googleIcon} alt='Google'/>
                                <p className='mb-0'>Posted on <br/> <a href={item.googleLink} target='_blank'>Google</a></p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}